import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

import * as Objects from '@core/objects';

import { NotesService } from '@core/services/notes/notes.service';
import { NotificationsService } from '@core/services/notifications/notifications.service';
import { AnnotationsService } from '@core/services/annotations/annotations.service';
import { InterfaceListenerService } from '@core/services/interface-listener/interface-listener.service';

import { PdfjsViewerAnnotationChanges } from '../../preview/pdfjs-viewer/pdfjs-viewer';
import { NotificationsContextEnum } from '../../../store/models/notifications.enum';
/**
 * @param urlAnnotationsPrefix is a specific url prefix for xfdf annotations
 */
@Component({
    selector: 'core-file-notes',
    templateUrl: './file-notes.component.html',
    styleUrls: ['./file-notes.component.scss']
})
export class FileNotesComponent implements OnInit, OnChanges, OnDestroy {
    public readonly SUCCESS = 2;
    public readonly ERROR = 1;
    public readonly PENDING = 0;

    @Input() file: Objects.File;
    @Input() user: Objects.User = null;
    @Input() urlPrefix: string = "";
    @Input() urlAnnotationsPrefix: string;
    @Input() urlSaveAnnotationsPrefix: string;
    @Input() context: string = "default";
    @Input() canCreateNotes: boolean = true;
    // @Input() canSign: boolean = true;
    @Input() notesAllowedUser: Objects.User = null;
    @Output() saved = new EventEmitter();

    public notes: Array<Objects.Note> = [];
    public annotations: string;
    public status: number = this.PENDING;

    private lnotesSubscriptor: Subscription;
    private xfdfAnnotSubscriptor: Subscription;

    constructor(private notesSrv: NotesService, private annotationsSrv: AnnotationsService, 
        private notifications :NotificationsService,
        private iListener: InterfaceListenerService ){}

    ngOnInit(){
        // when no specific prefix for xfdf annotations
        if( !this.urlAnnotationsPrefix) {
            this.urlAnnotationsPrefix = this.urlPrefix;
        }
        if(!this.urlSaveAnnotationsPrefix){
            this.urlSaveAnnotationsPrefix = this.urlAnnotationsPrefix;
        }
        this.init();

        
    }

    ngOnChanges(changes: SimpleChanges){
        // there is no no several files on same editor. Maybe we dont need this.
        if(changes.file) {
            this.notes = [];
        }
    }

    ngOnDestroy(): void {
        if(this.xfdfAnnotSubscriptor)
            this.xfdfAnnotSubscriptor.unsubscribe();
        if(this.lnotesSubscriptor)
            this.lnotesSubscriptor.unsubscribe();
    }

    protected init() {
        if (this.context == 'version') // when context version,  there is no notes
            return;
        // call for XFDF annotations first, if not load legacy notes
        this.loadAnnotations();
    }

    // save annotations for new format XFDF
    saveAnnotations(changes: PdfjsViewerAnnotationChanges) : void {
        this.annotationsSrv.save(this.file, changes, this.urlSaveAnnotationsPrefix, this.context).subscribe({
            next: (data: any) => {
                // TODO: view response and emit saved EVENT
                this.saved.emit();
                this.iListener.triggerFileAnnotationsSaved(this.file);
            
            },
            error: (err: HttpErrorResponse) => {
                this.annotations = '';
                if(!changes.legacy){ // only notification when there is a new note save failed
                    this.notifications.addNotification(NotificationsContextEnum.EVENT_FILE_ANNOTATIONS_UPDATED_FAILED, {id: this.file.id});
                }
                this.loadAnnotations(); // reload in caso of fail annotations post call
                
                console.debug(" annotations error saving ",err);

            }
        });
    }

    loadAnnotations(){
        this.xfdfAnnotSubscriptor = this.annotationsSrv.find(this.file, this.urlAnnotationsPrefix).subscribe({
            next: (annotationsXfdf: string) => { 
                if(annotationsXfdf != null ){
                    // console.debug(" xfdf annotations loaded are --> ",annotationsXfdf);   
                    this.annotations = annotationsXfdf;
                    this.status = this.SUCCESS;
                }
            },
            error: (err: HttpErrorResponse) => {
                if(err.status == 404){ // there are no notes saved for this file, we should try old notes
                    // load legacy notes 
                    this.loadLegacyNotes();
                } else {
                    console.debug(" xfdf annotations load error.",err);
                    this.status = this.ERROR;
                }
            }
        }); 

    }

    // may-2023: auto migration -> this function load old notes for the file only when there are not xfdf annotations
    loadLegacyNotes() {
        this.lnotesSubscriptor = this.notesSrv.find(this.file, this.urlPrefix).subscribe({
            next: (data: Array<Objects.Note>) => { 
                if(data != null ){
                    console.debug(" legacynotes data is ",data);
                    this.notes = (this.notesAllowedUser != null && data != null) ? data.filter((n:Objects.Note) => n.user.id == this.notesAllowedUser.id ) : data;
                    
                } 
                this.status = this.SUCCESS;
            },
            error: (err: HttpErrorResponse) =>{
                console.log(" legacy notes loading error. ");
                this.status = this.ERROR;
                
            }

        });
    }
    
}
